import React, { useEffect, useRef, useState } from 'react';
import { createWaLogo, LOGO_SETTLED_WITH_URL } from '../lib/waLogo';

/**
 * The opening, played full screen straight after a successful sign-in (and
 * only then — opening the app with a session already in place goes straight
 * in). The film logo draws itself into the solid WA mark, holds a beat with
 * WATCH ANYTHING under it, and the
 * overlay dissolves into the app. A click or a key lets anyone in early.
 */
const HOLD = 0.45;
const FADE = 0.6;

const Intro = ({ onDone }) => {
  const svg = useRef(null);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    // Motion someone has asked not to see is skipped outright, not shortened
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      onDone();
      return undefined;
    }
    const logo = createWaLogo(svg.current, { url: true });
    logo.play();

    const leave = setTimeout(() => setLeaving(true), (LOGO_SETTLED_WITH_URL + HOLD) * 1000);
    // Timers, not animationend: a tab that stops drawing frames would never
    // send it, and a black screen that never lifts is the worst way to fail
    const done = setTimeout(onDone, (LOGO_SETTLED_WITH_URL + HOLD + FADE) * 1000);
    window.addEventListener('keydown', onDone);
    return () => {
      logo.cancel();
      clearTimeout(leave);
      clearTimeout(done);
      window.removeEventListener('keydown', onDone);
    };
  }, [onDone]);

  return (
    <div className={`intro${leaving ? ' intro--out' : ''}`} aria-hidden="true" onClick={onDone}>
      {/* Shifted down 64 so the settled lockup (mark 250, address 598) sits
          in the middle of the screen rather than the scene's own centre */}
      <svg ref={svg} className="intro-logo" viewBox="0 64 1280 720" preserveAspectRatio="xMidYMid meet" />
    </div>
  );
};

export default Intro;
